"use client";
import styles from "./Checkout.module.css";
import { AiOutlineMinus, AiOutlinePlus, AiOutlineClose } from "react-icons/ai";
import { useState, useEffect } from "react";
import SmallCart from "../SmallCart/SmallCart";
import Link from "next/link";
import { CreatePaymentSession } from "@services/paymentAPI";
// import { calculatePriceAndFees } from "@helpers/calculatePriceAndFees";
import { useUser } from "@hooks/Auth/useUser";
import { useRouter, useSearchParams } from "next/navigation";
import { usePathname } from "next/navigation";
import GuestEmailDialog from "@components/GuestDialog/GuestEmailDialog";
import { useCookies } from "react-cookie";
import { FiAlertCircle } from "react-icons/fi";
import { Spinner } from "@components/Spinner/Spinner";
import VerifyEmail from "@components/VerifyEmail/VerifyEmail";
import Cookies from "js-cookie";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import VerifyPhoneDialog from "@components/VerifyPhone/verifyDialog";
import NationalityDialog from "@components/checkNationality/verifyDialog";
import { RequestVerification } from "@services/newLogin";
import RequestVerificationCode from "@components/LoginComponents/requestVerificationCode/requestVerificationCode";
import VerificationWay from "@components/LoginComponents/verificationWay/verificationWay";
import ChangeInfo from "@components/LoginComponents/changeInfo/changeInfo";
import { useLocation } from "@hooks/useLocation";
import config from "@config/config";
const RECAPTCHA_SITE_KEY = config.RECAPTCHA_SITE_KEY;
// The Checkout component is responsible for rendering the checkout view with all selected items.
const Checkout = (props) => {
  const {
    eventID,
    selectedItems = [], // Items that the user has selected
    absorbFees = false, // Whether the service fees are absorbed or not
    handleIncrement, // Function to handle incrementing item quantity
    handleDecrement, // Function to handle decrementing item quantity
    quantities, // The quantities of the selected items
    isInView = true, // Whether the checkout view is visible or not
    gateway,
    ticket,
    event,
    handleContinueAsGuest,
    utm_source = "",
    handleOpenPolicy
  } = props;
  const { user } = useUser();
  const pathname = usePathname();
  const {location, countryCode} = useLocation();
  const loc = {location, countryCode};
  const id = user?.id;
  const email = user?.email;
  const [sessionID, setSessionID] = useState();
  const [sessionMin, setSessionMin] = useState();
  const [isLoading, setLoading] = useState(false);
  const router = useRouter();
  const searchParams = useSearchParams();
  const utm_source1 = searchParams.get("utm_source");
  const [redirectUrl, setRedirectUrl] = useState(pathname);
  // // console.log(redirectUrl);
  const isUserEmpty = Object.keys(user).length === 0;
  // const priceObject = calculatePriceAndFees(selectedItems[0]);

  // State variable for continue as guest
  const [guest, setGuest] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [cookies, setCookies, removeCookies] = useCookies(["guestEmail"]);
  const handleDialogClose = () => {
    setGuest(false);
  };

  // for guest button
  const selectedguest = Cookies.get("testItems");

  let selectedItemGuest = { ...selectedguest };
  const parsed1 = JSON.parse(selectedguest);
  selectedItemGuest = { ...parsed1 }; // Override defaults with actual values if available
  // console.log({ parsed1 });
  // console.log({ selectedItemGuest });

  // console.log(selectedItemGuest && selectedItemGuest.continueAsGuest);
  //--------
  const handleGuestSubmit = (email, first, last, phone) => {
    setErrorEmail(false);
    setErrorPhone(false);
    // console.log(phone);
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (
      email === "" ||
      first === "" ||
      last === "" ||
      !email.match(validRegex)
    ) {
      // alert("Invalid email address");
      setErrorEmail(true);
      setGuest(true);
      return;
    }
    if (!isValidPhoneNumber(phone)) {
      // alert("Invalid email address");
      setErrorPhone(true);
      setGuest(true);
      return;
    }
    setCookies("guestEmail", email, { path: "/" });

    setCookies("guestFirstName", first, { path: "/" });
    setCookies("guestLastName", last, { path: "/" });
    setCookies("guestPhoneNumber", phone, { path: "/" });

    utm_source
      ? router.push(
          `/payment/${eventID}?isGuest=${guest}?utm_source=${utm_source}`
        )
      : router.push(`/payment/${eventID}?isGuest=${guest}`);
  };

  // State variables for managing the visibility of the checkout view
  const [minimized, setMinimized] = useState(false);
  const [visible, setVisible] = useState(isInView);

  // Function to toggle the visibility of the checkout view
  const toggleMinimized = () => {
    setMinimized(!minimized);
  };
  // State variable for managing the responsiveness of the component
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 750);

  const selected = Cookies.get("testItems");

  const getInitialSelectedItem = (selected) => {
    try {
      return selected ? JSON.parse(selected) : null;
    } catch (error) {
      console.error("Error parsing selected:", error);
      return null; // or a sensible default value for selectedItem
    }
  };

  const [selectedItem, setSelectedItem] = useState(
    getInitialSelectedItem(selected)
  );
// console.log({selected}, {selectedItem});

  // console.log({ selectedItem });
  // Calculate the total quantity of selected items
  // const totalQuantity = selectedItems.reduce(
  // (total, item) => total + item.quantity,
  // 0
  // );

  const totalQuantity = selectedItem.quantity;

  useEffect(() => {
    if (selected) {
      try {
        setSelectedItem(JSON.parse(selected));
      } catch (e) {
        console.error("Failed to parse selected:", e);
        // Optionally set a default state or handle the error as needed
      }
    }
  }, [selected]); // assuming `selected` is the actual dependency that should trigger this effect
  const [selectedPhoneMethod, setSlectedPhoneMethod] = useState(null);
  const [openVerifyPhone, setOpenVerifyPhone] = useState(false);

  const closeVerification = () => {
    setOpenVerifyPhone(false);
    // console.log(utm_source);
    utm_source
      ? router.push(`/payment/${eventID}?utm_source=${utm_source}`)
      : router.push(`/payment/${eventID}`);
  };

  // useEffect(() => {

  // }, [user]);
  const [openVerification, setOpenVerification] = useState({open:false, step: "", data:{}});

  const handleSuccessVerify = (data, token) => {
    Cookies.set(
      "user",
      JSON.stringify({
        id: data.uid,
        email: data.email,
        idToken: token,
        refreshToken: token,
        fname: data.firstName,
        lastName: data.lastName,
        country: data.address,
        phoneNumber: data.phoneNumber,
        gender: data.gender,
        dob: data.dob,
        updatedFields: data.updatedFields,
        username: data.userName,
        isPhoneVerified: data.isPhoneVerified,
        isEmailVerified: data.isEmailVerified,
      } )

    );
    Cookies.set("token", JSON.stringify(token));
    Cookies.set(
      "tokens",
      JSON.stringify({
        idToken: token,
        refreshToken: token,
      })
    );
    utm_source
          ? router.push(`/payment/${eventID}?utm_source=${utm_source}`)
          : router.push(`/payment/${eventID}`);
  }
  const handleOpenVerification = (data) => {

   setOpenVerification({open:true, step:"verify", data:data})
  }
  const handleRequestVerification = async (phoneVerified) => {
   if(phoneVerified) {
    setSlectedPhoneMethod(null)
    try {
                const siteKey = RECAPTCHA_SITE_KEY;
    const token = await grecaptcha.enterprise.execute(siteKey, { action: 'login' });   
      const {status, data} = await RequestVerification({
        recaptchaToken: token,
        method: "EMAIL",
        to: user.email,
        selectedPhoneMethod: null,
        source: "tickit.co",
      }, user.idToken);
      // console.log(status);
      
      if(status === 200) {
        handleOpenVerification(data.data);
      }
      
    } catch (error) {
      if(error.response.status === 401) {
        utm_source
        ? router.push(`/login/${eventID}?utm_source=${utm_source}`)
        : router.push(`/login/${eventID}`);
      }
      console.error(error);
      
    }
   }
   else {
    setOpenVerification({open:true, step:"way"});
   }
  }
  const handleChange = (data) => {
    setOpenVerification({open:true, step:"change", data:data})
  }
  const handleCheckout = (e, eventID) => {
    e.preventDefault();
    // setLoading(true);
    const phoneVerified = user.isPhoneVerified;
    const emailVerified = user.isEmailVerified;
// console.log(phoneVerified, emailVerified , phoneVerified || emailVerified);

    if(!phoneVerified || !emailVerified) {
      handleRequestVerification(phoneVerified)
    }
    else {
       if(event?.doorPolicy) {
      handleOpenPolicy("loggedIn");
    }
    else {
       utm_source
          ? router.push(`/payment/${eventID}?utm_source=${utm_source}`)
          : router.push(`/payment/${eventID}`);
    }
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [pathname]);

  // Effects for managing the visibility of the checkout view and the responsiveness of the component
  useEffect(() => {
    // Whenever the selectedItems change, make the checkout not minimized
    setMinimized(false);
  }, [selectedItems]);

  useEffect(() => {
    // Handle screen resize
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 750);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Control visibility based on screen size and isInView prop
    if (isLargeScreen) {
      setVisible(isInView);
    } else {
      setVisible(true);
    }
  }, [isInView, isLargeScreen]);

  // Get the currency of the selected items
  const currency = selectedItems[0].currency;

  function getTimeDifference() {
    const d1 = new Date(event.startDate._seconds * 1000);
    const d2 = new Date(Date.now());
    let diffTime = d1 - d2;
    let diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
    return diffHours;
  }
  // console.log(event);

  const handleLoginRedirect = () => {
    console.log(event.doorPolicy);
    
    if(event?.doorPolicy) {
      handleOpenPolicy("not loggedIn");
    }
    else {
    if(utm_source) router.push(`/login/${eventID}?utm_source=${utm_source}`);
    else router.push(`/login/${eventID}`);
    }
  };
  return (
    <>
      {/* {openVerifyPhone && (
        <VerifyPhoneDialog
          phoneNumber={true}
          closeVerification={closeVerification}
          event={event}
        />
      )} */}
      {openVerification.open && openVerification.step === "way" && (
        <VerificationWay
          phone={user}
          handleRequest={handleOpenVerification}
          isRequest={true}
          eventID={eventID}
          utm_source={utm_source}
          setSlectedPhoneMethod={setSlectedPhoneMethod}
        />
      )}
      {openVerification.open && openVerification.step === "verify" && (
        <RequestVerificationCode
          data={openVerification.data}
          onSuccess={handleSuccessVerify}
          user={user}
          handleChange={handleChange}
        />
      )}
      {openVerification.open && openVerification.step === "change" && (
        <ChangeInfo
          data={openVerification.data}
          onSuccess={handleOpenVerification}
          user={user}
          location={loc}
          selectedPhoneMethod={selectedPhoneMethod}
        />
      )}
      {errorEmail || errorPhone ? (
        <>
          {errorEmail && (
            <VerifyEmail
              title="Continue As Guest"
              message={"Invalid email address"}
              success={false}
              onVerified={() => {
                setGuest(true);
                setErrorEmail(false);
              }}
            />
          )}

          {errorPhone && (
            <VerifyEmail
              title="Continue As Guest"
              message={"Invalid phone number"}
              success={false}
              onVerified={() => {
                setGuest(true);
                setErrorPhone(false);
              }}
            />
          )}
        </>
      ) : (
        <div></div>
      )}
      {!guest ? (
        <div className={styles.wrapper}>
          {minimized && visible ? (
            <SmallCart
              totalQuantity={selectedItem.quantity}
              onCartClick={toggleMinimized}
            /> // Pass the toggleMinimized function as a prop
          ) : (
            <div className={styles.checkout}>
              {!isLargeScreen && (
                <AiOutlineClose
                  className={styles.closeButton}
                  onClick={toggleMinimized}
                />
              )}
              <div>
                <h5>x {totalQuantity}</h5>
                <h5>Selected items</h5>
              </div>
              <div className={styles.overflow}>
                {selectedItems.map((item) => (
                  <div key={item.waveID} className={styles.ticket_info}>
                    <div className={styles.ticket_info_row}>
                      <div className={styles.tName}>
                        <span>x{totalQuantity}</span>{" "}
                        <span className={styles.ticketName}>
                          {item.ticketName}
                        </span>
                      </div>
                      <div className={styles.right_section}>
                        <span>{item.basePrice.toFixed(2)}</span>
                        <span>{currency}</span>
                      </div>
                    </div>
                    {!isLargeScreen && (
                      <div className={styles.counter}>
                        <AiOutlineMinus
                          className={`${styles.logo} ${
                            quantities[item.waveID] === 0
                              ? styles["logo-disabled"]
                              : ""
                          }`}
                          onClick={() =>
                            handleDecrement(
                              item,
                              item.maxPerOrder,
                              item.currency,
                              ticket,
                              event,
                              item.minPerOrder,
                              ticket.incrementBy
                            )
                          }
                        />
                        <span className={styles.count}>
                          {quantities[item.waveID]}
                        </span>
                        <AiOutlinePlus
                          className={`${styles.logo} ${
                            quantities[item.waveID] === item.maxPerOrder ||
                            quantities[item.waveID] +
                              (ticket.incrementBy || 1) >
                              item.maxPerOrder
                              ? styles["logo-disabled"]
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              quantities[item.waveID] !== item.maxPerOrder &&
                              quantities[item.waveID] +
                                (ticket.incrementBy || 1) <=
                                item.maxPerOrder
                            ) {
                              console.log(ticket);

                              handleIncrement(
                                item,
                                item.maxPerOrder,
                                item.currency,
                                ticket,
                                event,
                                item.minPerOrder,
                                ticket.incrementBy
                              );
                            }
                          }}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className={styles.total}>
                {/* Conditionally render the service fees */}
                {(!selectedItems.absorbFees ||
                  !selectedItems.absorbPaymentFees) && (
                  <>
                    <div className={styles.row}>
                      <span>Sub Total</span>
                      <div className={styles.right_section}>
                        <span>
                          {(
                            selectedItems[0].basePrice * selectedItem.quantity
                          ).toFixed(2)}
                        </span>
                        <span>{currency}</span>
                      </div>
                    </div>
                    {/* <div className={styles.row}>
                      <span>Service Fees</span>
                      <div className={styles.right_section}>
                        <span>
                          {(
                            selectedItems[0].serviceFees *
                            selectedItems[0].quantity
                          ).toFixed(2)}
                        </span>
                        <span>{currency}</span>
                      </div>
                    </div> */}
                  </>
                )}
                <div
                  className={styles.row}
                  style={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                    opacity: "80%",
                  }}
                >
                  <FiAlertCircle /> &nbsp; <span>Excluding Service Fees</span>
                </div>
                {/* <div className={styles.row}>
                  <span>Total</span>
                  <div className={styles.right_section}>
                    <span>
                      {(
                        selectedItems[0].customerPrice *
                        selectedItems[0].quantity
                      ).toFixed(2)}
                    </span>
                    <span>{currency}</span>
                  </div>
                </div> */}
              </div>

              {isUserEmpty ? (
                <div className="choose-way">
                  <button
                    // onClick={() => {
                    //   // handleSelectedItem();
                    // }}

                    className={styles.btn}
                    onClick={handleLoginRedirect}
                  >
                    Next
                  </button>

                  {selectedItemGuest && selectedItemGuest.continueAsGuest && (
                    <>
                      <div className={styles.divider}>
                        <span></span>
                        <span>OR</span>
                        <span></span>
                      </div>
                      {/* <Link
                        href={
                          utm_source1
                            ? `/guest/${eventID}?utm_source=${utm_source}`
                            : `/guest/${eventID}`
                        }
                        className={styles.guestButton}
                      > */}
                      <button
                        className={styles.btn}
                        onClick={(e) => {
                          e.preventDefault();
                          if (event?.doorPolicy) {
                            handleOpenPolicy("guest");
                          } else {
                            router.push(
                              utm_source
                                ? `/guest/${eventID}?utm_source=${utm_source}`
                                : `/guest/${eventID}`
                            );
                          }
                        }}
                      >
                        Continue As Guest
                      </button>
                      {/* </Link> */}
                    </>
                  )}
                </div>
              ) : (
                <button
                  className={styles.btn}
                  onClick={(e) => {
                    // handleSelectedItem();
                    handleCheckout(e, eventID);
                  }}
                >
                  {isLoading ? <Spinner /> : "Checkout"}
                </button>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.wrapper}>
          {" "}
          <GuestEmailDialog
            onClose={() => setGuest(false)}
            isOpen={guest}
            onSubmit={handleGuestSubmit}
            handleContinueAsGuest={handleContinueAsGuest}
          />
        </div>
      )}
    </>
  );
};

export default Checkout;
